import { Component, Input, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-nav-item',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './app-nav-item.html',
  styleUrls: ['./app-nav-item.css']
})
export class AppNavItemComponent {
  @Input() item!: any; 
  @Input() isCollapsed = false;
  @Input() depth = 0;

  expanded = signal(false);
  private router = inject(Router);

  isActive(): boolean {
    if (!this.item?.route) return false;
    const active = this.router.isActive(this.item.route, {
      paths: this.item.exact ? 'exact' : 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored'
    });
    if (active) return true;
    
    if (this.item.children) {
        return this.item.children.some((c: any) => this.router.url === c.route);
    }
    return false;
  }

  toggleExpand(event: Event) {
    if (this.item.children?.length) {
      event.preventDefault();
      this.expanded.update(v => !v);
    }
  }
}
